module.exports = __webpack_public_path__ + "static/media/Enscape_2022-10-13-11-46-09.f2c0934c.jpg";